import React, { useState } from 'react';
import { useCheckpointAuthStore } from '../stores/checkpointAuthStore';
/**
 * Página de Login Simplificada para o Shortcode de Checkpoint.
 * Focada apenas no formulário de acesso para líderes.
 */
function ShortcodeLoginPage({ onLoginSuccess }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const login = useCheckpointAuthStore((state) => state.login);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const result = await login(email, password);
            if (result.success) {
                if (onLoginSuccess) onLoginSuccess();
            } else {
                setError(result.error || 'Credenciais inválidas. Verifique seu login e senha.');
            }
        } catch (err) {
            setError('Ocorreu um erro ao tentar fazer login.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="checkpoint-interface" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8f9fa' }}>
            <div className="cp-modal-content" style={{ maxWidth: '400px', borderRadius: '24px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', padding: '40px 30px' }}>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <div style={{ 
                        width: '64px', height: '64px', background: 'linear-gradient(135deg, #0A58CA 0%, #043b8c 100%)', 
                        borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', 
                        margin: '0 auto 16px', color: 'white', fontSize: '32px', fontWeight: 800 
                    }}>H</div>
                    <h1 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#111827' }}>Portal do Líder</h1>
                    <p style={{ color: '#6B7280', fontSize: '0.9rem', marginTop: '8px' }}>Acesse para realizar a gestão e o checkpoint da sua célula.</p>
                </div>

                {error && (
                    <div style={{ background: '#ffebe6', color: '#bf2600', padding: '12px', borderRadius: '12px', fontSize: '0.85rem', marginBottom: '20px', textAlign: 'center', border: '1px solid #ffbdad' }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div>
                        <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 700, color: '#6B778C', marginBottom: '6px', textTransform: 'uppercase' }}>Email ou Usuário</label>
                        <input 
                            type="text" 
                            className="cp-notes-input" 
                            style={{ margin: 0, background: 'white' }}
                            placeholder="exemplo@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 700, color: '#6B778C', marginBottom: '6px', textTransform: 'uppercase' }}>Senha</label>
                        <input 
                            type="password" 
                            className="cp-notes-input" 
                            style={{ margin: 0, background: 'white' }}
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        className="cp-submit-btn" 
                        disabled={loading}
                        style={{ marginTop: '20px' }}
                    >
                        {loading ? 'A verificar...' : 'Entrar no Sistema'}
                    </button>
                </form>

                <p style={{ textAlign: 'center', marginTop: '24px', fontSize: '0.8rem', color: '#6B778C' }}>
                    Problemas com o acesso? Contacte o seu supervisor para definir a sua senha em <strong>Rede de Pessoas</strong>.
                </p>
            </div>
        </div>
    );
}

export default ShortcodeLoginPage;
